/**
 * Flint Fires - Col Showcase
 * Horizontal scroll carousel with navigation
 */

class FlintCollectionShowcase {
  constructor(section) {
    this.section = section;
    this.wrapper = this.section.querySelector('[data-carousel-wrapper]');
    this.carousel = this.section.querySelector('[data-carousel]');
    this.flickity = null;
    
    if (!this.wrapper || !this.carousel) return;
    
    this.init();
  }
  
  /**
   * Wait for Flickity library to load (same pattern as product hero)
   */
  waitForFlickity() {
    return new Promise((resolve) => {
      const checkFlickity = () => {
        if (typeof Flickity !== 'undefined') {
          resolve();
        } else {
          setTimeout(checkFlickity, 50);
        }
      };
      checkFlickity();
    });
  }
  
  /**
   * Initialize Flickity instance (same pattern as product hero)
   */
  initFlickity() {
    // ONLY get existing instance - let data-flickity handle creation
    // Wait for it to be ready
    const waitForInstance = () => {
      this.flickity = Flickity.data(this.carousel);
      
      if (!this.flickity) {
        console.log('Waiting for data-flickity to initialize...');
        setTimeout(waitForInstance, 50);
      } else {
        console.log('Flickity instance found!', this.flickity);
        
        // Set up video observer after Flickity is ready
        this.setupVideoObserver();
      }
    };
    
    waitForInstance();
  }
  
  init() {
    // Wait for Flickity library to load, then wait for data-flickity instance
    this.waitForFlickity().then(() => {
      this.initFlickity();
    });
  }
  
  /**
   * Intersection Observer for video performance
   * Pause videos when out of viewport, play when in viewport
   */
  setupVideoObserver() {
    const videos = this.carousel.querySelectorAll('.flint-collection__product-video');
    
    if (videos.length === 0) return;
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        
        if (entry.isIntersecting) {
          // Video is in viewport - play it
          video.play().catch(err => {
            console.log('Video autoplay prevented:', err);
          });
        } else {
          // Video is out of viewport - pause it
          video.pause();
        }
      });
    }, {
      threshold: 0.5 // Trigger when 50% visible
    });
    
    // Observe all videos
    videos.forEach(video => observer.observe(video));
  }
}

/**
 * Initialize all Flint Collection Showcase sections on the page
 */
document.addEventListener('DOMContentLoaded', () => {
  const showcaseSections = document.querySelectorAll('.flint-collection-showcase');
  
  console.log('Found showcase sections:', showcaseSections.length);
  
  showcaseSections.forEach((section, index) => {
    console.log(`Initializing showcase section ${index + 1}:`, section);
    new FlintCollectionShowcase(section);
  });
});

/**
 * Handle Shopify section editor events (Theme Customizer)
 */
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.flint-collection-showcase');
    if (section) {
      new FlintCollectionShowcase(section);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target.querySelector('.flint-collection-showcase');
    if (section && section.flintShowcaseInstance) {
      section.flintShowcaseInstance.destroy();
    }
  });
}
